import styled, { css } from "styled-components";
import { ChevronUp, ChevronDown, Mouse } from "@styled-icons/boxicons-regular";
import { motion } from "framer-motion";
import { fonts } from "styles";

interface ChevronButton {
  slide?: number;
  isMobile?: boolean;
}

export const Container = styled.div`
  width: 100vw;
  height: 100%;
  min-height: 100vh;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  .next,
  .prev {
    top: calc(50% - 20px);
    position: absolute;
    background: white;
    border-radius: 30px;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    user-select: none;
    cursor: pointer;
    font-weight: bold;
    font-size: 18px;
    z-index: 2;
  }

  .next {
    right: 10px;
  }

  .prev {
    left: 10px;
    transform: scale(-1);
  }

  @media screen and (max-width: 960px) {
    height: auto;
  }
`;

export const Slide = styled(motion.div)`
  position: absolute;
  width: 100vw;
  height: 100vh;

  @media screen and (max-width: 960px) {
    height: 100%;
    min-height: 100vh;
    overflow-y: auto;
  }
`;

export const IconLeft = styled(ChevronUp).attrs({ size: 32 })<ChevronButton>`
  color: white;
`;

export const IconRight = styled(ChevronDown).attrs({
  size: 32,
})<ChevronButton>`
  color: white;
`;

export const Controls = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  right: 88px;
  top: center;
  z-index: 99;

  @media screen and (max-width: 1366px) {
    right: 48px;
  }

  @media screen and (max-width: 960px) {
    display: none;
  }
`;

export const ButtonPrevMobile = styled.button.attrs({ type: "button" })`
  display: none;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: center;
  top: 16px;
  z-index: 99;

  @media screen and (max-width: 960px) {
    display: flex;
  }
`;

export const ButtonNextMobile = styled.button.attrs({ type: "button" })`
  display: none;
  position: absolute;
  left: center;
  bottom: 24px;
  z-index: 99;
  background-color: white;
  padding: 10px 23px;
  max-height: 37px;
  border-radius: 18.5px;
  color: black;
  font-family: ${fonts.BentonSansMedium};
  font-size: 12px;
  line-height: 28px;
  text-transform: uppercase;
  align-items: center;
  justify-content: center;

  span {
    display: flex;
    font-size: 14px;
    margin-right: 9px;
  }

  @media screen and (max-width: 960px) {
    display: flex;
  }
`;

export const ButtonPrev = styled.button.attrs({ type: "button" })`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;

  &.slick-disabled {
    opacity: 0.5;
  }
`;

export const ButtonNext = styled.button.attrs({ type: "button" })`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;

  &.slick-disabled {
    opacity: 0.5;
  }
`;

export const NumbersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 110px;
  row-gap: 16px;
  position: relative;
  overflow: hidden;
  scroll-snap-type: y mandatory;
  scroll-behavior: smooth;
  transition: 300ms ease;
`;

interface NumberProps {
  active: boolean;
}
export const Number = styled.button.attrs({ type: "button" })<NumberProps>`
  font-size: 16px;
  font-family: ${fonts.BentonSansWideBold};
  color: white;
  width: 32px;
  height: 24px;
  flex-shrink: 0;
  flex-grow: 0;
  transition: 300ms ease;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;

  &:last-child {
    margin-bottom: 8px;
  }

  ${({ active }) =>
    active &&
    css`
      transform: scale(1.3);
      ::after {
        position: absolute;
        bottom: -3px;
        content: "";
        display: block;
        width: 80%;
        height: 2px;
        background-color: #e7b757;
      }
    `}
`;

export const ScrollInfo = styled.div`
  display: flex;
  align-items: center;
  font-size: 13px;
  line-height: 22px;
  font-family: ${fonts.BentonSansRegular};
  letter-spacing: 1px;
  color: white;
  text-transform: uppercase;
  position: absolute;
  bottom: 32px;

  pointer-events: none;
  z-index: 99;

  @media screen and (max-width: 960px) {
    display: none;
  }
`;

export const IconMouse = styled(Mouse).attrs({ size: 24 })`
  color: #43e4c1;
  margin-right: 8px;
  transition: 300ms;
  animation-name: jump;
  animation-duration: 700ms;
  animation-timing-function: ease-in-out;
  animation-direction: alternate;
  animation-fill-mode: both;
  animation-iteration-count: infinite;

  @keyframes jump {
    0% {
      transform: translateY(0);
    }

    100% {
      transform: translateY(-5px);
    }
  }
`;
